import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import { isExternalVideo } from 'shared/ui-selectors/video/video-origin';

import ExternalPlayer from './external/external';
import InternalPlayer from './internal/internal';


@WixConnect()
export default class Video extends React.Component {

  static propTypes = {
    videoItem: React.PropTypes.object.isRequired,
    videoUrls: React.PropTypes.object,
  };

  render() {
    const { videoUrls, videoItem } = this.props;
    const isExternal = isExternalVideo(videoItem);

    if (!isExternal && !videoUrls) {
      return null;
    }

    const PlayerComponent = isExternal ? ExternalPlayer : InternalPlayer;

    const props = _.omit(this.props, 'intl', 'styles');

    return (
      <PlayerComponent {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/video/video.js